(function ($) {
  $(".alert").each(function () {
    $(this).on("click", ".close", function () {
      $(this).closest(".alert").slideUp(200);
    });
  });
})(jQuery);
